/**
 * @generated SignedSource<<8ec868f764d0c0fa6808d96cb756fc49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportSurveysCompletedStatisticsCardFragment$data = {
  readonly surveysCompletedReport: {
    readonly totalAvailable: number;
    readonly totalCompleted: number;
  };
  readonly " $fragmentType": "MemberReportSurveysCompletedStatisticsCardFragment";
};
export type MemberReportSurveysCompletedStatisticsCardFragment$key = {
  readonly " $data"?: MemberReportSurveysCompletedStatisticsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportSurveysCompletedStatisticsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportSurveysCompletedStatisticsCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "OrganizationMembershipReportingSurveysCompletedReportResponse",
      "kind": "LinkedField",
      "name": "surveysCompletedReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCompleted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalAvailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "45e600d1d4782024e787fec5023b295c";

export default node;
